
<v-app class="font-lato report-templates-detail">

  <div class="report-detail-container position-relative">
    <!-- Sidebar -->
    <RightSidebar />
    <!-- Column Index New -->
    <ColumnIndex />
    <!-- Content -->
    <ColumnDetail />
    <!-- Footer -->
    <FooterAction />
  </div>

  <ModalConfirmation v-if="isConfirmShow" />
  <Banner :banner="banner" />
</v-app>
